import React from 'react';
import PropTypes from 'prop-types';

import { List } from '@zillow/constellation';

export default function BodySectionList({ list }) {
  return (
    <List>
      {list.map((listItem) => {
        const text = typeof listItem === 'object' ? listItem.text : listItem;

        return (
          <List.Item key={text} paddingY={0}>
            {text}
          </List.Item>
        );
      })}
    </List>
  );
}

BodySectionList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        text: PropTypes.string,
      }),
    ]),
  ).isRequired,
};
